import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import {
    MENU_ROLE
} from '../actions';

import {
    MenuRoleSuccess,
    MenuRoleError
} from '../actions';

export function* watchMenuRole() {
    yield takeEvery(MENU_ROLE, onMenuRole);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onMenuRoleAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'menu/datamenu', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


function* onMenuRole(data) {
    try {
        const response = yield call(onMenuRoleAsync, data.payload);
        yield put(MenuRoleSuccess(response.data));
    } catch (error) {
        yield put(MenuRoleError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchMenuRole)
    ]);
}

